import React from "react";

export default function SobreComponent(props) {

    return (
        <div className="content">
            <div className="row no-gutters justify-content-center mt-5 mb-10 ml-5 mr-5">
                <div className="col-md-8 block block-rounded block-bordered mb-5 mt-5">
                    <div className="block-content">
                        <p>
                            O Reclame Rio não é apenas um site de reclamações. A ideia vai muito além de possibilitar que você, usuário, possa se manifestar a respeito de problemas. Este site visa criar um canal eficiente e transparente entre clientes e empresas, dando voz ao consumidor do Estado do Rio de Janeiro.
                            <br/>
                            <br/>
                            Os sites de reclamação e consultas do mercado atualmente não avaliam as empresas de forma regionalizada, pois apresentam um panorama nacional de avaliação. Uma empresa pode atuar de maneira eficiente no Estado do Rio de Janeiro mas com péssima qualidade em outro Estado, ou vice versa. O Reclame Rio avalia as empresas de forma regionalizada, trazendo mais eficiência neste serviço e deixando bem claro ao consumidor Fluminense como estas atuam na sua região.
                            <br/>
                            <br/>
                            Antes de comprar um produto ou contratar um serviço, você pode pesquisar quais são as empresas mais confiáveis para fazer um bom negócio. Acreditamos que este site vai melhorar o relacionamento entre fornecedores e clientes, de forma transparente e colaborativa.
                            <br/>
                            <br/>
                            É o Reclame Rio somando forças com a população do Estado do Rio de Janeiro.
                        </p>
                        <a className="btn btn-dark mb-3" href="#/"><i className="fa fa-arrow-left"/> Voltar</a>
                    </div>
                </div>
            </div>
        </div>
    )
}